"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.asObjectFactory = void 0;
/**
 * Determine whether the given key can be used to specify an object property. This is true if, and only if,
 * it is of type string, number or symbol.
 *
 * @param key The key.
 * @returns Whether the key is of a valid type.
 */
function isObjectAssignable(key) {
    return typeof key === 'string' || typeof key === 'number' || typeof key === 'symbol';
}
/**
 * Create an ObjectCollector for the given grouping.
 *
 * @param groups The grouping.
 * @returns The created collector.
 */
function asObjectFactory(groups) {
    return () => {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const obj = {};
        for (const group of groups) {
            if (isObjectAssignable(group.key)) {
                obj[group.key] = group.items;
            }
        }
        return obj;
    };
}
exports.asObjectFactory = asObjectFactory;
